export const leafFile = {
  title: '施工图',
  cancel: '取消',
  ok: '确定',
  send2Member: '发送给项目成员',
  move: '移动',
  delete: '删除',
  newDirectory: '新建文件夹',
  oversizeAlert: '文件过大，暂时展示前5页，稍后为您展示其他图纸',
  loading: '加载中',
  uploadFile: '上传文件',
  rename: '重命名',
  name: '文件夹名称',
  deleteAlert: '删除后文件不可恢复',
}
